<template>
  <div class="makeIndexApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul>
      <li v-for="(item,i) in setMake">
        <h2>
          <el-image style="width: 25px;border-radius:6px;height:25px;float:left;margin:7.5px 5px 0 0" :src="baseUrl+item.img" fit="cover"></el-image><span>{{item.title}}</span>
        </h2>
        <p>地址：{{item.address}}</p>
        <p>营业时间：{{item.business}}</p>
        <p>预约时间：{{item.starttime}} ~ {{item.endtime}}</p>
        <p></p>
        <p></p>
        <div class="btn">
          <a href="javascript:;"@click="$router.push('gathermake?id='+item.id)">去预约<i class="el-icon-arrow-right"></i></a>
        </div>
      </li>
    </ul>
    <div class="none" v-if="setMake.length <= 0">暂无数据~</div>
  </div>
</template>

<script>
  import $ from 'jquery'
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: true,
        userData:[],
        setMake:[],
        baseUrl:'',
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
      });
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var url = encodeURIComponent('http://user.4008005216.com/main/gatherscenic');
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
          this.login();
        }
      }
    },
    mounted() {
      this.beforeMount();
      if(localStorage.getItem('userjwt') != null){
        this.getMake();
      }
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      getMake:function(){
        var that = this;
        that.fullscreenLoading = true;
        $.ajax({
          type:'post',
          url:that.$host+'home/gather/getMake',
          dataType:'json',
          success:function(data){
            if(data.status == 200){
              that.setMake = data.data;
            }else{
              that.$alert(data.message,'提示');
            }
            that.fullscreenLoading = false;
          }
        })
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.userData = res.data;
          that.getscenic();
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .makeIndexApp{
    display:block;
    background:#ececec;
    width:100%
  }
  .makeIndexApp ul{
    width:96%;
    margin:0 auto;
    padding-top:12px
  }
  .makeIndexApp ul li{
    background:#fff;
    width:100%;
    border-radius:6px;
    padding-bottom:12px;
    margin-bottom:12px
  }
  .makeIndexApp ul li h2{
    height:40px;
    width:94%;
    margin:0 auto;
    font-size:15px;
    line-height:40px;
  }
  .makeIndexApp ul li h2 span{
    float:left;
    width:calc(100% - 30px);
    height:40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color:#1C222B
  }
  .makeIndexApp ul li p{
    width:92%;
    margin:0 auto;
    font-size:14px;
    line-height:22px;
    color:#555;
    padding:3px 0 5px 0
  }


  .makeIndexApp ul li .btn{
    width:94%;
    margin:0 auto;
    text-align:right;
  }
  .makeIndexApp ul li .btn a{
    display:inline-block;
    width:80px;
    height:30px;
    line-height:30px;
    text-align:center;
    border: 1px solid #0052D9;
    color:#0052D9;
    border-radius: 30px;
    font-size:15px;
    text-decoration: none;
  }
  .makeIndexApp .none{
    font-size:14px;
    color:#6b6b6b;
    text-align:center;
    padding-top:70%;
  }
</style>